const conveniosPaciente = [
  {
    id: 1,
    label: '4) Convênio do paciente',
    name: 'convenio_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Operadoras de saúde',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Particular',
        value: '2',
      },
      {
        id: 3,
        descricao: 'SUS',
        value: '3',
      },
    ],
  },
];

const dependencia = [
  {
    id: 1,
    label:
      '7) O paciente apresentava limitação total para caminhada ou outras atividades que requeiram o uso dos membros inferiores',
    name: 'dependencia_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim – relacionada com a artropatia de quadril',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Sim – relacionada com outros motivos que não a artropatia',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const comorbidades = [
  {
    id: 1,
    label: 'a) Infarto agudo do miocárdio',
    name: 'iam_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: 'b) Insuficiência cardíaca',
    name: 'ic_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: 'c) Doença vascular periférica',
    name: 'dvp_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 4,
    label: `d) AVC ou AIT`,
    name: 'avc_ait_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 5,
    label: `e) Demência`,
    name: 'demencia_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 6,
    label: `f) DPOC`,
    name: 'dpoc_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 7,
    label: `g) Doença do tecido conjuntivo`,
    name: 'dtc_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 8,
    label: `h) Doença hepática`,
    name: 'hepatica_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 9,
    label: `i) Diabetes mellitus`,
    name: 'dm_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 10,
    label: `j) Doença renal crônica`,
    name: 'drc_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 11,
    label: `k) Tumor sólido`,
    name: 'tumor_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 12,
    label: `l) Leucemia`,
    name: 'leucemia_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 13,
    label: `m) Linfoma`,
    name: 'linfoma_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 14,
    label: `n) AIDS`,
    name: 'aids_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const internacaoEPolitrauma = [
  {
    id: 1,
    label:
      '10) Caráter da internação hospitalar para realização da artroplastia total de quadril',
    name: 'internacao_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Urgência por fratura',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Eletiva',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: '11) Paciente politraumatizado',
    name: 'politrauma_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const profilaxiaECoagulacao = [
  {
    id: 1,
    label:
      '16) Paciente recebeu profilaxia para tromboembolismo venoso durante a internação',
    name: 'profilaxia_tv_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 2,
    label: '17) Paciente em uso de anticoagulação plena durante a internação',
    name: 'anticoagulacao_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
  {
    id: 3,
    label: '18) Paciente foi submetido à avaliação sistemática da dor',
    name: 'dor_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao:
          'Não realizado, pois o paciente estava impossibilitado de responder ao questionário',
        value: '98',
      },
    ],
  },
];

const dataEHoraChegada = [
  {
    id: 1,
    label: 'Data da chegada no hospital',
    name: 'entrada_data_quadril',
  },
  {
    id: 2,
    label: `Hora da chegada no hospital`,
    name: 'entrada_hora_quadril',
  },
];

const dataEHoraAdmissao = [
  {
    id: 1,
    label: `Data da admissão do paciente no centro cirúrgico`,
    name: 'admissao_data_quadril',
  },
  {
    id: 2,
    label: `Hora da admissão do paciente no centro cirúrgico`,
    name: 'admissao_hora_quadril',
  },
];

const dataEHoraIncisao = [
  {
    id: 5,
    label: `Data da incisão cirúrgica`,
    name: 'incisao_data_quadril',
  },
  {
    id: 6,
    label: `Hora da incisão cirúrgica`,
    name: 'incisao_hora_quadril',
  },
];

const dataEHoraMomentoSentar = [
  {
    id: 1,
    label:
      'Data do primeiro momento em que o paciente ficou sentado após a cirurgia',
    name: 'sentar_data_quadril',
  },
  {
    id: 2,
    label: `Hora do primeiro momento em que o paciente ficou sentado após a cirurgia`,
    name: 'sentar_hora_quadril',
  },
];

const dataEHoraMomentoDeambular = [
  {
    id: 3,
    label: `Data do primeiro momento em que o paciente deambulou após a cirurgia`,
    name: 'deambular_data_quadril',
  },
  {
    id: 4,
    label: `Hora do primeiro momento em que o paciente deambulou após a cirurgia`,
    name: 'deambular_hora_quadril',
  },
];

const dataEHoraSaida = [
  {
    id: 1,
    label: 'Data da saída',
    name: 'saida_data_quadril',
  },
  {
    id: 2,
    label: `Hora da saída`,
    name: 'saida_hora_quadril',
  },
];

const dataEHoraAntibiotico = [
  {
    id: 1,
    label: `Data da administração de antibioticoterapia profilática`,
    name: 'antibiotico_data_quadril',
  },
  {
    id: 2,
    label: `Hora da administração de antibioticoterapia profilática`,
    name: 'antibiotico_hora_quadril',
  },
];

const covidQuadril = [
  {
    id: 1,
    label: '21) Paciente teve diagnóstico de COVID-19 durante a internação',
    name: 'covid_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
      {
        id: 3,
        descricao: 'Não testado',
        value: '2',
      },
    ],
  },
];

const motivoSaida = [
  {
    id: 1,
    label: '22) Motivo da saída hospitalar',
    name: 'saida_motivo_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Alta médica ',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Óbito',
        value: '2',
      },
      {
        id: 3,
        descricao: 'Evasão',
        value: '3',
      },
      {
        id: 3,
        descricao: 'Transferência',
        value: '4',
      },
    ],
  },
];

const confortoPaliativo = [
  {
    id: 1,
    label: '24) Paciente em medidas de conforto ou cuidados paliativos',
    name: 'paliativo_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const pacienteReinternou = [
  {
    id: 1,
    label: '25) Paciente reinternou em até 30 dias após a saída da instituição',
    name: 'reinternacao_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const reinternacaoQuadril = [
  {
    id: 1,
    label: '26) Reinternação foi por motivo relacionado à ATQ',
    name: 'reinternacao_motivo_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const apresentouInfeccao = [
  {
    id: 1,
    label:
      '27) Paciente apresentou infecção de sítio cirúrgico em até 3 meses do procedimento',
    name: 'infeccao_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];

const dataDiagnostico = [
  {
    id: 1,
    label: '28) Data do diagnóstico de infecção',
    name: 'infeccao_data_quadril',
  },
];

const seguimentoReinternacao = [
  {
    id: 1,
    label: '29) Paciente foi a óbito no período de até 1 ano após a alta',
    name: 'obito_seg_quadril',
    opcoes: [
      {
        id: 1,
        descricao: 'Sim',
        value: '1',
      },
      {
        id: 2,
        descricao: 'Não',
        value: '0',
      },
    ],
  },
];


export {
  dependencia,
  conveniosPaciente,
  comorbidades,
  internacaoEPolitrauma,
  dataEHoraChegada,
  dataEHoraAdmissao,
  dataEHoraIncisao,
  dataEHoraAntibiotico,
  profilaxiaECoagulacao,
  dataEHoraMomentoSentar,
  dataEHoraMomentoDeambular,
  dataEHoraSaida,
  covidQuadril,
  motivoSaida,
  confortoPaliativo,
  pacienteReinternou,
  apresentouInfeccao,
  seguimentoReinternacao,
  reinternacaoQuadril,
  dataDiagnostico,
};
